import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion, AnimatePresence } from "framer-motion";

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "AI & Tech", href: "#ai-tech" },
  { label: "Global Transit", href: "#global" },
  { label: "Consulting", href: "#consulting" },
  { label: "Contact", href: "#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const scrollTo = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    el?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass-dark">
      <div className="container mx-auto flex items-center justify-between h-16 px-4 lg:px-8">
        <a href="#" className="block" aria-label="TheBigUSA LLC - Home">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 350 80" className="h-10 w-auto">
            <defs>
              <linearGradient id="aiGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#06b6d4" />
                <stop offset="100%" stopColor="#2563eb" />
              </linearGradient>
            </defs>
            <g transform="translate(10, 15)">
              <path d="M25 5 L45 15 L45 35 L25 45 L5 35 L5 15 Z" fill="none" stroke="currentColor" strokeWidth="3" strokeLinejoin="round" className="text-primary-foreground" />
              <path d="M25 25 L5 15 M25 25 L45 15 M25 25 L25 45" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" className="text-primary-foreground" />
              <circle cx="25" cy="5" r="4" fill="url(#aiGradient)" />
              <circle cx="5" cy="35" r="4" fill="url(#aiGradient)" />
              <circle cx="45" cy="35" r="4" fill="url(#aiGradient)" />
              <circle cx="25" cy="25" r="3" fill="#06b6d4" />
              <path d="M25 5 L25 25" stroke="url(#aiGradient)" strokeWidth="2" strokeDasharray="2,2" />
            </g>
            <g transform="translate(70, 45)">
              <text x="0" y="0" fontFamily="system-ui, sans-serif" fontSize="32" fontWeight="800" fill="currentColor" letterSpacing="-1.5" className="text-primary-foreground">
                TheBig<tspan fill="#06b6d4">USA</tspan>
              </text>
              <text x="160" y="0" fontFamily="system-ui, sans-serif" fontSize="18" fontWeight="600" fill="#64748b">LLC</text>
              <text x="2" y="18" fontFamily="system-ui, sans-serif" fontSize="10" fontWeight="700" fill="#64748b" letterSpacing="2.5">AI-POWERED LOGISTICS</text>
            </g>
          </svg>
        </a>

        {/* Desktop */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="text-sm text-muted-foreground hover:text-cyan transition-colors"
            >
              {l.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("#contact")}
            className="bg-cyan text-navy-deep font-semibold hover:bg-cyan-glow rounded-full px-6 text-sm"
          >
            Get a Quote
          </Button>
        </div>

        {/* Mobile toggle */}
        <button className="md:hidden text-muted-foreground" onClick={() => setOpen(!open)} aria-label={open ? "Close menu" : "Open menu"}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden glass-dark border-t border-cyan/10"
          >
            <div className="flex flex-col gap-1 p-4">
              {navLinks.map((l) => (
                <button
                  key={l.href}
                  onClick={() => scrollTo(l.href)}
                  className="text-left py-3 px-4 text-sm text-muted-foreground hover:text-cyan transition-colors rounded-lg hover:bg-cyan/5"
                >
                  {l.label}
                </button>
              ))}
              <Button
                onClick={() => scrollTo("#contact")}
                className="mt-2 bg-cyan text-navy-deep font-semibold hover:bg-cyan-glow rounded-full"
              >
                Get a Quote
              </Button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
